/**
 * Copyright 2014 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { __extends } from "tslib";
import { EventDispatcher } from '../events/EventDispatcher';
import { notImplemented, release } from '@awayfl/swf-loader';
// Class: GameInputDevice
var GameInputDevice = /** @class */ (function (_super) {
    __extends(GameInputDevice, _super);
    function GameInputDevice() {
        return _super.call(this) || this;
    }
    Object.defineProperty(GameInputDevice.prototype, "numControls", {
        // _numControls: number /*int*/;
        // _sampleInterval: number /*int*/;
        // _enabled: boolean;
        // _id: string;
        // _name: string;
        get: function () {
            release || notImplemented('public flash.ui.GameInputDevice::get numControls');
            return;
            // return this._numControls;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GameInputDevice.prototype, "sampleInterval", {
        get: function () {
            release || notImplemented('public flash.ui.GameInputDevice::get sampleInterval');
            return;
            // return this._sampleInterval;
        },
        set: function (val /*int*/) {
            val = val | 0;
            release || notImplemented('public flash.ui.GameInputDevice::set sampleInterval');
            return;
            // this._sampleInterval = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GameInputDevice.prototype, "enabled", {
        get: function () {
            release || notImplemented('public flash.ui.GameInputDevice::get enabled');
            return;
            // return this._enabled;
        },
        set: function (val) {
            val = !!val;
            release || notImplemented('public flash.ui.GameInputDevice::set enabled');
            return;
            // this._enabled = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GameInputDevice.prototype, "id", {
        get: function () {
            release || notImplemented('public flash.ui.GameInputDevice::get id');
            return;
            // return this._id;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GameInputDevice.prototype, "name", {
        get: function () {
            release || notImplemented('public flash.ui.GameInputDevice::get name');
            return;
            // return this._name;
        },
        enumerable: true,
        configurable: true
    });
    GameInputDevice.prototype.getControlAt = function (i /*int*/) {
        i = i | 0;
        release || notImplemented('public flash.ui.GameInputDevice::getControlAt');
        return;
    };
    GameInputDevice.prototype.startCachingSamples = function (numSamples /*int*/, controls) {
        numSamples = numSamples | 0;
        controls = controls;
        release || notImplemented('public flash.ui.GameInputDevice::startCachingSamples');
        return;
    };
    GameInputDevice.prototype.stopCachingSamples = function () {
        release || notImplemented('public flash.ui.GameInputDevice::stopCachingSamples');
        return;
    };
    GameInputDevice.prototype.getCachedSamples = function (data, append) {
        if (append === void 0) { append = false; }
        data = data;
        append = !!append;
        release || notImplemented('public flash.ui.GameInputDevice::getCachedSamples');
        return;
    };
    // Called whenever the class is initialized.
    GameInputDevice.classInitializer = null;
    // List of static symbols to link.
    GameInputDevice.classSymbols = null; // [];
    // List of instance symbols to link.
    GameInputDevice.instanceSymbols = null; // [];
    GameInputDevice.MAX_BUFFER_SIZE = 4800;
    return GameInputDevice;
}(EventDispatcher));
export { GameInputDevice };
